var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 58 58",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 7,
    style: {
      fill: "#C3E1ED",
      stroke: "#E7ECED",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    width: 56,
    height: 44
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ED8A19"
    },
    cx: 16,
    cy: 17.569,
    r: 6.569
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1A9172"
    },
    points: "56,36.111 55,35 43,24 32.5,35.5 37.983,40.983 42,45 56,45 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1A9172"
    },
    points: "2,49 26,49 21.983,44.983 11.017,34.017 2,41.956 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 45,
    style: {
      fill: "#6B5B4B"
    },
    width: 54,
    height: 5
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#25AE88"
    },
    points: "37.983,40.983 27.017,30.017 10,45 42,45 "
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/ImageIcon.228a5ce7270ac40018c896bd4ea15a77.svg";
export { ForwardRef as ReactComponent };